import { http, type NetworkResponse } from '../network_new';
import network from '../network';
import { storeToRefs } from 'pinia';
import { useTenantStore } from '../tenant';
import { useUserStore } from '../user';
import { getChanCode } from '@star/utils';
import { ActivityDetailResponse, ActivityTabBarResponse } from '@star/types';

const useActivityServices = () => {
  const tenantStore = useTenantStore();
  const { tenantInfo } = storeToRefs(tenantStore);
  const userStore = useUserStore();
  const { isLogin, getUserInfo } = storeToRefs(userStore);

  //console.log('tenantInfo.value.tid', tenantInfo.value.tid);

  const activityServices = {
    /**
     * 请求优惠活动Tab数据
     */
    getActivityData(params?: Record<string, any>) {
      const cmdId = 723606;

      const data = {
        // type: getChanCode(), // 设备码。 IOS/ANDROID/MWEB
        tid: tenantInfo.value.tid, //  平台数据上的 tid
        // chan_con: getChanCode(),
        // language: 0, // 前期客户端语言
        // proxy: 0, // 平台数据上的 proxy
        ...params,
      };
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 1, apiName: 'getActivityTab' },
      });
    },

    getActivityDataVO(params?: Record<string, any>) {
      // const cmdId = 380237;
      const cmdId = 723606; //azhe说全部换成这个

      const data = {
        type: getChanCode(), // 设备码。 IOS/ANDROID/MWEB
        tid: tenantInfo.value.tid, //  平台数据上的 tid
        chan_con: getChanCode(),
        language: 0, // 前期客户端语言
        proxy: 0, // 平台数据上的 proxy
        ...params,
      };
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getActivityTabVO' },
      });
    },

    /**
     * 请求活动详情
     */
    getActivityDetail(params: { page_start: number; num_per_page: number; activityCategory: string }) {
      const cmdId = 723601;

      const data = {
        tid: tenantInfo.value.tid,
        ...params,
      };
      return http.post<ActivityDetailResponse>('/v1', data, {
        headers: { cmdId, paramType: 1, apiName: 'getActivityList' },
      });
    },

    getActivityDetailVO(cat: string, typeId: number | undefined) {
      const cmdId = 380238;

      const data: any = {
        apply: 3, // 1 棋牌；2 网赚；3 综合彩票；3 老版彩票； (apply后端设置默认为1，为可选参数)
        //cat: cat === '全部活动' ? '-' : cat,
        chan_con: getChanCode(),
        type: getChanCode(),
        language: 0,
        tid: tenantInfo.value.tid,
        proxy: 0,
        typeId: typeId,
      };
      if (isLogin.value) {
        data.cust_id = getUserInfo.value?.cust_id;
      }
      return http.post<ActivityDetailResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getActivityListVO' },
      });
    },
    // 查询领取预存奖励
    getPrestoreReward(params: { tasks_id: any }) {
      const cmdId = 725100;
      const data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
        tasks_id: params.tasks_id,
      };
      return http.post<ActivityDetailResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getPrestoreReward' },
      });
    },
    // 申请新的预存奖励
    prestoreRewardMoney(params: { tasks_id: any }) {
      const cmdId = 725101;
      const data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
        tasks_id: params.tasks_id,
      };
      return http.post<ActivityDetailResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getPrestoreReward' },
      });
    },
    /**
     * 请求优惠活动提交申请查询
     */
    getActiveFormQuery(bulletinId: number) {
      const cmdId = 380523;

      const data = {
        bulletin_id: bulletinId,
        tid: tenantInfo.value.tid,
      };

      return http.post<ActivityDetailResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getActiveFormQuery' },
      });
    },

    // 活动详情
    getActivityContentDetail(params?: any) {
      const cmdId = 723603;
      const data = {
        tid: tenantInfo.value.tid,
        ...params,
      };
      console.log('services.activity请求活动详情-post-data---->', data);

      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 1, apiName: 'getActivityContentDetail' },
      });
    },

    // 获取自定义活动可用次数111
    getAvailablequantity(params?: any) {
      const cmdId = 725001;
      const data = {
        tid: tenantInfo.value.tid,
        ...params,
      };
      // console.log('请求自定义活动剩余次数参数----', data);
      return http.post('/v1', data, {
        headers: { cmdId, apiName: 'getAvailablequantity' },
      });
    },

    // 申请自定义活动
    applyCustomActivity(params?: any) {
      const cmdId = 725002;
      const data = {
        tid: tenantInfo.value.tid,
        ...params,
      };
      // console.log('申请自定义活动参数----', data);
      return http.post('/v1', data, {
        headers: { cmdId, paramType: 1, apiName: 'applyCustomActivity' },
      });
    },
    // 获取ip
    getIp(params?: any) {
      const cmdId = 370725;
      const data = {
        ...params,
      };
      // console.log('getip参数', data);
      return http.post('/v1', data, {
        headers: { cmdId, paramType: 1, apiName: 'getIp' },
      });
    },
    // 获取自定义活动申请记录
    getCustomActivityApplyRecord(params?: any) {
      const cmdId = 725004;
      const data = {
        tid: tenantInfo.value.tid,
        ...params,
      };
      // console.log('自定义活动申请记录请求参数725004', data);
      return http.post('/v1', data, {
        headers: { cmdId, apiName: 'getCustomActivityApplyRecord' },
      });
    },
    // 申请自定义活动点选验证111
    customizeActivityVerificationCode(params?: any) {
      const cmdId = 102;
      const data = {
        ...params,
      };
      // console.log('申请自定义活动点选验证', data);
      return http.post('/v1', data, {
        headers: { cmdId, paramType: 1, apiName: 'customizeActivityVerificationCode' },
      });
    },

    // 活动支付类型
    getPayOrgOptions(params?: any) {
      const cmdId = 371237;
      const data = {
        tid: tenantInfo.value.tid,
        cat: '1,2',
        currency: -1,
        name: -1,
        state: '1',
        type: '-1',
      };
      console.log('活动支付类型', data);
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getPayOrgOptions' },
      });
    },
    // 幸运注单活动详情
    getLuckBetDetail(params?: any) {
      const cmdId = 7242032;
      const data = {
        tid: tenantInfo.value.tid,
        ...params,
      };
      console.log('services.activity请求活动详情-post-data---->', data);

      return http.post('/v1', data, {
        headers: { cmdId, apiName: 'getLuckBetDetail' },
      });
    },

    checkLuckBetBlance(params?: any) {
      const cmdId = 7242030;
      const data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
      };
      console.log('services.activity请求活动详情-post-data---->', data);

      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, apiName: 'checkLuckBetBlance' },
      });
    },

    reqLuckNotes(params: any = {}) {
      const cmdId = 322939;
      let data = {
        ...params,
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
        game_type: -1,
        state: -1,
      };

      return http.post('/v1', data, {
        headers: { cmdId, apiName: 'reqLuckNotes' },
      });
    },
    // 立即领取 幸运注单
    async getAward(params: any = {}) {
      // 发起请求
      const cmdId = 7242031;
      let data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
      };
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, apiName: 'getAward' },
      });
    },
    // 活动申请
    activityApply(params?: any) {
      const cmdId = 621115;

      const data = {
        tid: tenantInfo.value.tid,
        acctId: getUserInfo.value.cust_id,
        account: getUserInfo.value.cust_name,
        applyDeviceType: getChanCode(),
        applyIp: '127.0.0.1',
        applyDevice: getChanCode(),
        status: '1', // 0=待审核,1=已通过,2=已拒绝
        ...params,
      };
      console.log('621115--1', data);
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 1, apiName: 'activityApply' },
      });
    },
    // 用户支付次数
    getPayCount(params?: any) {
      const cmdId = 725102;
      const data = {
        tid: tenantInfo.value.tid, //商户ID
        cust_id: getUserInfo.value.cust_id, //用户id
        ...params,
      };
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getPayCount' },
      });
    },
    // 获取排行榜详情
    getRankData(params?: any) {
      const cmdId = 621114;

      const data = {
        tid: tenantInfo.value.tid,
        acctId: getUserInfo.value.cust_id,
        ...params,
      };
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 1, apiName: 'getRankData' },
      });
    },

    // 获取排行榜列表
    getRankList(params?: Record<string, any>) {
      const cmdId = 621113;

      const data = {
        tid: tenantInfo.value.tid,
        acctId: getUserInfo.value.cust_id,
        ...params,
      };
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 1, apiName: 'getRankList' },
      });
    },

    //救援金-领取
    reliefFundGet(params?: Record<string, any>) {
      const cmdId = 724209;
      const data = {
        tid: tenantInfo.value.tid, //商户ID
        cust_id: getUserInfo.value.cust_id, //用户id
        ...params,
      };
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'reliefFundGet' },
      });
    },

    //救援金-可领取奖励信息查询
    reliefFundInfo(params?: Record<string, any>) {
      console.log('tenantInfo', tenantInfo.value);
      const data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
        ...params,
      };
      console.log('services.activity救援金-领取接口-post-data---->', data);
      return network.request({
        cmdId: 7242020,
        data: data,
        paramType: 0,
      });
    },

    // 新人彩金-用户使用兑换优惠码接口
    userExchangeCouponCode(params?: Record<string, any>) {
      const cmdId = 621116;
      console.log('tenantInfo', tenantInfo.value);
      const data = {
        tid: tenantInfo.value.tid,
        acctId: getUserInfo.value.acct_id,
        account: getUserInfo.value.cust_name,
        applyIp: '127.0.0.1',
        // promoCode: getChanCode(),
        ...params,
      };
      console.log('services.activity兑换优惠码-post-data---->', data);
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 1, apiName: 'userExchangeCouponCode' },
      });
    },

    // 723624-新人彩金-获取优惠码接口 // 621116-用户兑换优惠码接口
    userGetCouponCode(params?: Record<string, any>) {
      const cmdId = 723624;

      const data = {
        tid: tenantInfo.value.tid,
        acctId: getUserInfo.value.acct_id,
        account: getUserInfo.value.cust_name,
        //applyIp: '127.0.0.1',
        // promoCode: getChanCode(),
        ...params,
      };
      console.log('services.activity获取优惠码723624-post-data---->', data);
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 1, apiName: 'userGetCouponCode' },
      });
    },

    getAwardReq(params?: Record<string, any>) {
      const cmdId = 621112;

      const data = {
        tid: tenantInfo.value.tid,
        acctId: getUserInfo.value.cust_id,
        custId: getUserInfo.value.cust_id,
        account: getUserInfo.value.cust_name,
        ...params,
      };
      console.log('services.activity获取优惠码723624-post-data---->', data);
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 1, apiName: 'getAwardReq' },
      });
    },

    // 获取打码活动奖励信息
    getBetAwardInfo(params?: Record<string, any>) {
      const cmdId = 7242021;

      const data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
        ...params,
      };

      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getBetAwardInfo' },
      });
    },

    // 打码奖励领取
    getBetAward(params?: Record<string, any>) {
      const cmdId = 724209;

      const data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
        receive_log_id: params?.receive_log_id,
        ...params,
      };
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getBetAward' },
      });
    },

    getRechareInfo(params?: Record<string, any>) {
      const cmdId = 7242022;

      const data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
        ...params,
      };

      return http.post<Record<string, any>>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getRechareInfo' },
      });
    },

    // 待领取-奖励领取
    getWaitReceiveAward(params?: Record<string, any>) {
      const cmdId = 395015;

      const data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
        ...params,
      };
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getWaitReceiveAward' },
      });
    },

    // 待领取-一键领取奖励
    getWaitReceiveAwardAll(params?: Record<string, any>) {
      const cmdId = 395017;

      const data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
        ...params,
      };
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getWaitReceiveAwardAll' },
      });
    },

    // 待领取-待领取数
    getWaitReceiveNum(params?: Record<string, any>) {
      const cmdId = 395016;

      const data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
        ...params,
      };
      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getWaitReceiveNum' },
      });
    },

    // 首页活动浮动轮播列表
    getActiveActivityList(params?: Record<string, any>) {
      const cmdId = 383008;

      const data: any = {
        tid: tenantInfo.value.tid,
        ...params,
      };
      if (getUserInfo.value?.cust_id) {
        data.cust_id = getUserInfo.value.cust_id;
      }
      return http.post<
        NetworkResponse<{
          count: number;
          data: Array<{
            link_name: string;
            slideshow_address: string;
            pic_addr: string;
          }>;
        }>
      >('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getActiveActivityList' },
      });
    },

    // 获取千万福利图标
    getWelfareIcons(params?: Record<string, any>) {
      const cmdId = 370730;

      const data = {
        tid: tenantInfo.value.tid,
        ...params,
      };

      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getActiveActivityModalList' },
      });
    },

    // 首页活动弹窗列表
    getActiveActivityModalList(params?: Record<string, any>) {
      const cmdId = 7242044;

      const data = {
        tid: tenantInfo.value.tid,
        ...params,
      };

      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getActiveActivityModalList' },
      });
    },

    // 是否可领取红包
    getHasRedPackets(params?: Record<string, any>) {
      const cmdId = 7242045; //7242040

      const data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
        ...params,
      };

      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getHasRedPackets' },
      });
    },
    // 领取红包奖励
    getRedPacketsAward(params?: Record<string, any>) {
      const cmdId = 7242041;

      const data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
        ...params,
      };

      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getRedPacketsAward' },
      });
    },

    // 红包雨可领剩余次数
    getRedPacketsRemainingCount(params?: Record<string, any>) {
      const cmdId = 7242043;

      const data = {
        tid: tenantInfo.value.tid,
        cust_id: getUserInfo.value.cust_id,
        ...params,
      };

      return http.post<ActivityTabBarResponse>('/v1', data, {
        headers: { cmdId, paramType: 0, apiName: 'getRedPacketsAward' },
      });
    },
  };

  return {
    activityServices,
  };
};

export default useActivityServices;
